// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loading[data-v-259622f2]\n{\n\tmargin: 20px;\n\ttext-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
